/**
 * フレーム → 描くもの（索引 Issue #498 の段階 2。設計文書 §5）。**プレビューと書き出しの共通の契約**。
 *
 *   timeline = buildTimeline(...)        データが変わったときだけ
 *   frame    = frameAt(ms, timeline)     1 フレームごと
 *
 * 描画側（`editorPorts/duelRenderer.js::duelStageLayers`）が受け取るのはこの `frame` だけ。
 */
import { statesAt } from './states';

/** その時刻に出ている項目（隠したもの・長さ 0 は出ない） */
const itemsAt = (ms, items = []) => items.filter((o) => !o.hidden && o.startMs <= ms && ms < o.endMs);

export function frameAt(ms, timeline) {
  const items = itemsAt(ms, timeline?.items ?? []).map((item) => {
    const localMs = ms - item.startMs;
    const durationMs = item.endMs - item.startMs;
    return {
      ...item,
      localMs,
      remainingMs: item.endMs - ms,
      progress: durationMs > 0 ? Math.min(1, Math.max(0, localMs / durationMs)) : 1,
    };
  });
  return {
    ms,
    items,
    // **可変尺で出しっぱなしのもの**（チェーン・LP・ターン・盤面など）はここ。値はその時刻のもの
    states: statesAt(ms, timeline?.states ?? {}),
  };
}
